import images from "../../common/images";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../utils/openAppRedirect";

const StoreButtons = ({ className = "" }) => {
  return (
    <div className={`app-btn azzir-store-buttons ${className}`.trim()}>
      <a
        target="_blank"
        rel="noreferrer"
        className="btn"
        href={PLAY_STORE_URL}
      >
        <img
          src={images.androidDownload}
          className="img-fluid"
          alt="Get Azzir on Google Play"
        />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        className="btn"
        href={APP_STORE_URL}
      >
        <img
          src={images.appleDownload}
          className="img-fluid"
          alt="Download Azzir on the App Store"
        />
      </a>
    </div>
  );
};

export default StoreButtons;
